<template>
  <div>
    <div class="mt-2">
      <p>Selecciona las opciones de entrega que deseas ofrecer a tus clientes durante el proceso de compra. A
        continuación, te mostramos los métodos de envío disponibles para tu tienda, para que elijas entre ofrecer todas
        las opciones o solo algunas. Por defecto <strong>'Despacho a Domicilio'</strong> ya está seleccionado, y puedes
        complementar esta opción con otras según las necesidades de tu negocio.</p>
    </div>

    <div class="mt-4 mb-4">
      <div class="container">
        <div class="row">
          <OptionDeliveryCard v-model="selectedHome" title="Retiro en Tienda">
            <template #icon>
              <TiendaIcon :size="{ width: 45, height: 45 }" />
            </template>
          </OptionDeliveryCard>
          <OptionDeliveryCard v-model="selectedPudo" title="Retiro en Punto" subtitle="[Sucursal Courier]">
            <template #icon>
              <SucursalIcon :size="{ width: 45, height: 45 }" />
            </template>
          </OptionDeliveryCard>
          <OptionDeliveryCard v-model="selectedDelivery" title="Despacho a Domicilio" :disabled="true">
            <template #icon disabled>
              <DomicilioIcon :size="{ width: 45, height: 45 }" />
            </template>
          </OptionDeliveryCard>
        </div>
      </div>
    </div>

    <div>
      <b-form-group>
        <b-form-checkbox id="home" name="checkbox-home" :disabled="!selectedHome" v-model="freeShippingHome">
          <p class="mb-2">¿Deseas establecer el <strong>'Retiro en Tienda'</strong> como una opción de envío gratuito?
            Activa esta opción si quieres que tus clientes puedan retirar sus pedidos sin costo en tu tienda.</p>
        </b-form-checkbox>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox id="pudo" name="checkbox-pudo" :disabled="!selectedPudo" v-model="freeShippingPudo">
          <p>¿Deseas establecer el <strong>'Retiro en Punto'</strong> como una opción de envío gratuito? Activa esta
            opción
            si quieres que tus clientes puedan retirar sus pedidos sin costo en una sucursal del courier</p>
        </b-form-checkbox>
      </b-form-group>
    </div>
    <div class="w-full d-flex justify-content-end">
      <b-button variant="warning" :disabled="!canContinue" @click="continuar">Continuar</b-button>
    </div>
  </div>
</template>
<script>
import TiendaIcon from '@/Icons/TiendaIcon.vue'
import SucursalIcon from '@/Icons/SucursalIcon.vue'
import DomicilioIcon from '@/Icons/DomicilioIcon.vue'
import OptionDeliveryCard from '../components/OptionDeliveryCard.vue'

export default {
  name: 'TabDelivery',
  props: {
    canContinue: {
      type: Boolean,
      default: false
    }
  },
  components: {
    OptionDeliveryCard,
    TiendaIcon,
    SucursalIcon,
    DomicilioIcon
  },
  data() {
    return {
      selectedHome: false,
      selectedPudo: false,
      selectedDelivery: true, // Por defecto 'Despacho a Domicilio' está seleccionado
      freeShippingHome: false,
      freeShippingPudo: false
    }
  },
  watch: {
    selectedHome(val) {
      this.emitSelection()
      if (!val) this.freeShippingHome = val
    },
    selectedPudo(val) {
      this.emitSelection()
      if (!val) this.freeShippingPudo = val
    },
    selectedDelivery: 'emitSelection'
  },
  methods: {
    emitSelection() {
      this.$emit(
        'delivery-customized',
        this.selectedHome || this.selectedPudo || this.selectedDelivery
      )
    },
    selectedFreeShippingHome() {
      this.$emit('selectedFreeShippingHome', this.freeShippingHome)
      console.log('selectedFreeShippingHome', this.freeShippingHome)
    },
    selectedFreeShippingPudo() {
      this.$emit('selectedFreeShippingPudo', this.freeShippingPudo)
      console.log('selectedFreeShippingPudo', this.freeShippingPudo)
    },
    continuar() {
      this.$emit('continuar')
    }
  },
  mounted() {
    this.emitSelection()
  }
}
</script>